module.exports = __webpack_public_path__ + "img/uninstall.5014bf2f.jpg";